// 商务经理
let menuBusinessManager = [
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    {
        path: '/p0',
        component: "HomeView",
        name: '营销管理',
        redirect:'/common/problemFeedbackList',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"反馈管理",
                children:[
                    // {
                    //     path:"/common/problemFeedbackList",
                    //     component:"ProblemFeedbackView",
                    //     name:"问题反馈"
                    // },
                    {
                        path:"/common/problemFeedbackDetail",
                        hidden:true,
                        component:"ProblemFeedbackDetailView",
                        name:"问题反馈详情"
                    },
                ]
            },
            
        ]
    },
    // {
    //     path: '/p1',
    //     component: "HomeView",
    //     name: '运营管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p2',
    //     component: "HomeView",
    //     name: '合同管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p4',
    //     component: "HomeView",
    //     name: '材料管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p5',
    //     component: "HomeView",
    //     name: '财务管理',
    //     disable:true,//无权限
    // },
    
    {
        path: '/p6',
        component: "HomeView",
        name: '项目总监管理',
        redirect:'/ba/cm/projectManagerList',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"项目总监",
                children:[
                    // {
                    //     pageAddress:"ProjectManagerListView",
                    //     path:"/ba/cm/projectManagerList",
                    //     component:"ProjectManagerListView",
                    //     name:"项目总监总表"
                    // },
                    {
                        pageAddress:"ba/BAProjectManagerEditView",
                        path:"/ba/pm/edit",
                        hidden:true,
                        component:"BAProjectManagerEditView",
                        name:"编辑项目总监"
                    },
                    {
                        pageAddress:"bm/BMProjectManagerReadView", 
                        path:"/ba/pm/read_view",
                        hidden:true,
                        component:"BMProjectManagerReadView",
                        name:"项目总监详情"
                    },
                    {
                        pageAddress:"bm/BMProjectManagerEditMoreView",
                        path:"/bm/pm/editMore",
                        hidden:true,
                        component:"BMProjectManagerEditMoreView",
                        name:"编辑项目总监更多信息"
                    },
                    // {
                    //     pageAddress:"cm/CMIntroducerIndexView",
                    //     path:"/cm/introducer/index",
                    //     component:"CMIntroducerIndexView",
                    //     name:"项目总监关系管理"
                    // },
                    {
                        pageAddress:"cm/CMIntroducerInfoView",
                        path:"/cm/introducer/info",
                        hidden:true,
                        component:"CMIntroducerInfoView",
                        name:"查看介绍人"
                    },
                    {
                        pageAddress:"cm/CMIntroducerInfo",
                        path:"/cm/introducer/infor",
                        hidden:true,
                        name:"项目总监关系管理详情"
                    },
                ]
            },
            
        ]
    },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
    {
		path:'/p8',
        redirect: '/me/change_password',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // { 
                    //     path: '/me/change_password', 
                    //     component: "ChangePasswordView", 
                    //     name: '修改密码' 
                    // },		
                ]
            }
        ]

    }
];

export default menuBusinessManager;


// WEBPACK FOOTER //
// ./src/menu/menuBusinessManager.js